import {shapes} from "@joint/core";
import {defaults} from "./Defaults";


const customShapesInternalMap = new Map();

customShapesInternalMap.set('FloatingRectangle', shapes.standard.TextBlock.define('custom.FloatingRectangle', {
    attrs: {
        label: {
            fontSize: defaults.floatingBoxFontSize,
            'font-weight': 'bold',
            textAnchor: 'middle',
            refX: '50%',
            refY: '50%',
            yAlignment: 'middle',
            style: {
                color: defaults.elementTextColor,
            }
        },
        body: {
            fill: defaults.elementFill,
            stroke: defaults.elementActiveBorderColor,
            strokeWidth: defaults.elementActiveStrokeWidth,
            rx: defaults.elementsBorderRadius,
            ry: defaults.elementsBorderRadius
        }
    }
}));

export const standardLink = (source, target, foreignKey) => {
  return new shapes.standard.Link({
      source: {
          id: target,
          port: foreignKey
      },
      target: {
          id: source
      },
      attrs: {
          line: {
              stroke: defaults.linkPassiveColor,
              strokeWidth: defaults.elementPassiveStrokeWidth,
              strokeDasharray: defaults.linkPassiveStrokeDasharray
          }
      }
  });
}

export const generateHeaderedBox = (name, x, y, ports = []) => {
    let height = getNodeHeight(ports);
    let rectangle = new shapes.standard.HeaderedRectangle({
        id: name,
        ports: {
            groups: {
                'in': getPortsInConfig()
            }
        },
        attrs: {
            root: {
                title: shapes.standard.HeaderedRectangle,
            },
            header: {
                fill: defaults.elementFill,
                stroke: defaults.elementPassiveBorderColor,
                strokeWidth: defaults.elementPassiveStrokeWidth,
                rx: defaults.elementsBorderRadius,
                ry: defaults.elementsBorderRadius,
            },
            headerText: {
                text: name
            },
            body: {
                fill: defaults.elementFill,
                stroke: defaults.elementPassiveBorderColor,
                strokeWidth: defaults.elementPassiveStrokeWidth,
                rx: defaults.elementsBorderRadius,
                ry: defaults.elementsBorderRadius,
            }

        }
    });
    rectangle.resize(defaults.nodeWidth, height);
    rectangle.position(x - (defaults.nodeWidth / 2), y - (height / 2));
    rectangle.addPorts(ports.map((portName) => createPort(portName)));
    return rectangle;
}

export const getNodeHeight = (ports) => {
    let height = defaults.nodeHeight;
    if (ports.length > 1) {
        height += ports.length * defaults.nodePortHeight;
    }
    return height;
}


const createPort = (title) => {
    let defaultConfig = {
        id: title,
        group: 'in',
        attrs: {
            label: {
                text: title,
            }
        }
    };
    if (title.endsWith('(self)')) {
        defaultConfig.attrs.portBody = {
            fill: defaults.elementPassiveBorderColor,
            stroke: defaults.elementPassiveBorderColor,
            r: defaults.portSelfRadius,
        }
    }
    return defaultConfig;
}

const getPortsInConfig = () => {
    return {
        position: {
            name: 'line',
            args: {
                start: {x: 0, y: 30},
                end: {x: 0, y: '100%'}
            }
        },
        attrs: {
            portBody: {
                r: defaults.portRadius,
                fill: defaults.elementFill,
                stroke: defaults.elementPassiveBorderColor,
                strokeWidth: defaults.elementPassiveStrokeWidth
            }
        },
        label: {
            position: {
                name: 'right'
            },
            markup: [{
                tagName: 'text',
                selector: 'label',
                className: 'label-text'
            }]
        },
        markup: [{
            tagName: 'circle',
            selector: 'portBody'
        }]
    };
}

export const customShapesMap = customShapesInternalMap;